// extracted by mini-css-extract-plugin
export default {"wrapper":"copyright-module--wrapper--583d4"};